import { render, staticRenderFns } from "./ComponentConteudoObstaculosVendaInternet.vue?vue&type=template&id=4198d916&scoped=true&"
import script from "./ComponentConteudoObstaculosVendaInternet.vue?vue&type=script&lang=js&"
export * from "./ComponentConteudoObstaculosVendaInternet.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConteudoObstaculosVendaInternet.vue?vue&type=style&index=0&id=4198d916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4198d916",
  null
  
)

export default component.exports